
import { SvgImageEditor } from "@/components/SvgImageEditor"
import { NozzleShape } from "@/services/admin/nozzle-shape/NozzleShape.modal"
import { createNozzleShapes, updateNozzleShape } from "@/services/admin/nozzle-shape/NozzleShape.service"
import { useRequest } from "ahooks"
import { Form, Input, Modal, ModalProps } from "antd"
import { useEffect, useState } from "react"
import { createRoot } from "react-dom/client"
import styles from './index.module.less';

interface CreateNozzleShapeProps extends ModalProps {
  nozzleShape?: NozzleShape
  onSuccess?: () => void
}

export function CreateEditNozzleShape(props: CreateNozzleShapeProps) {
  const { onSuccess, onCancel, nozzleShape } = props
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()

  useEffect(() => {
    if (nozzleShape) {
      form.setFieldsValue(nozzleShape)
    }
  }, [nozzleShape])

  const { loading, run } = useRequest(
    (values) => {
      if (nozzleShape) {
        return updateNozzleShape(nozzleShape.id, values)
      }
      return createNozzleShapes(values)
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess?.()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }


  return <Modal
    {...props}
    width={600}
    visible={visible}
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>Add Nozzle Shape</div>
    <Form
      form={form}
      onFinish={(values) => {
        run(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter Nozzle Shape name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Image' name='svg' rules={[{ required: true, message: 'Please enter image' }]}>
        <SvgImageEditor disabled={!!nozzleShape} disableClassName={styles.disabledSvg} />
      </Form.Item>
    </Form>
  </Modal>
}

CreateEditNozzleShape.show = (props: CreateNozzleShapeProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div); // createRoot(container!) if you use TypeScript
  root.render(<CreateEditNozzleShape
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
  />);
}